import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsPageView } from '../../utils/analytics';

// Report every SPA navigation to GA4 and Meta.
//
// Both platforms only auto-report the FIRST page: gtag('config') sends one
// page_view when it loads, and the Meta base code fires PageView once. React
// Router navigations after that changed the URL without any script reload, so
// GA4 showed one page per session and Meta attributed the whole visit to the
// landing page — which is why the funnel reports looked broken.
export default function PageViewTracker() {
  const location = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    const path = location.pathname + location.search;
    // The initial load is already counted by gtag('config') / the base pixel;
    // reporting it again here would double every session's landing page.
    if (lastPath.current === null) {
      lastPath.current = path;
      return;
    }
    if (lastPath.current === path) return;
    lastPath.current = path;

    // Let the route's own effects set document.title first — GA4 records the
    // title at send time, and sending synchronously captures the previous page's.
    const t = setTimeout(() => analyticsPageView(path), 300);
    return () => clearTimeout(t);
  }, [location.pathname, location.search]);

  return null;
}
